import styled from "@emotion/styled";
import { Input } from "antd";

export const StyledSearchInput = styled(Input.Search)<{ direction: "ltr" | "rtl" }>`
  border-radius: 0.25rem;
  border: 1px solid rgb(152, 152, 152);
  margin-bottom: 1.5rem;
  gap: 1rem;
  box-shadow: none;

  .ant-input-wrapper {
    display: flex;

    .ant-input {
      padding: 0.75rem;
      border: 0;

      ${({ direction }) =>
        direction === "ltr"
          ? "border-top-left-radius: 0.5rem; !important"
          : "border-top-right-radius: 0.5rem; !important"};

      ${({ direction }) =>
        direction === "ltr"
          ? "border-bottom-left-radius: 0.5rem; !important"
          : "border-bottom-righ-radius: 0.5rem; !important"};

      &:focus {
        box-shadow: none !important;
      }
    }

    .ant-input-group-addon {
      width: 60px;
      left: unset !important;
      border: 0;
      display: flex;

      ${({ direction }) =>
        direction === "ltr"
          ? "border-left: 1px solid rgb(152, 152, 152) !important;"
          : "border-right: 1px solid rgb(152, 152, 152) !important;"};

      .ant-btn {
        width: 100%;
        height: 100%;
        border: 0;

        ${({ direction }) =>
          direction === "ltr"
            ? "border-top-right-radius: 0.5rem; !important"
            : "border-top-left-radius: 0.5rem; !important"};

        ${({ direction }) =>
          direction === "ltr"
            ? "border-bottom-right-radius: 0.5rem; !important"
            : "border-bottom-left-radius: 0.5rem; !important"};

        .anticon {
          svg {
            width: 1.5rem;
            height: 1.5rem;
          }
        }
      }
    }
  }

  &:before {
    content: none;
  }

  input {
    font-size: 1.25rem;
    line-height: 1;
  }

  .ant-input-prefix {
    margin-right: 0;

    svg {
      width: 1.15rem;
    }
  }

  @media screen and (max-width: 576px) {
    margin-bottom: 1rem;

    .ant-input-wrapper {
      .ant-input {
        font-size: 1rem;
        padding: 0.5rem 1rem;
      }

      .ant-input-group-addon {
        width: 50px;

        .ant-btn .anticon svg {
          height: 1rem;
          width: 1rem;
        }
      }
    }
  }
`;
